import { Component, OnDestroy, OnInit } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';
import { EventsService } from '../../services/events.service';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    imports: [
      ToastModule,
    ],
})
export class NotificationsComponent implements OnInit, OnDestroy {

  constructor(private events: EventsService, private messageService: MessageService) {
  }

  onAlert = (message: ToastMessageOptions) => {
    this.messageService.add(message);
  };

  ngOnInit() {
    this.events.subscribe('alert', this.onAlert);
  }

  ngOnDestroy() {
    this.events.unsubscribe('alert', this.onAlert);
  }
}
